export default "/img/icon-bookkeeping.svg"